/* eslint-disable */
import React from 'react';
import { IconType } from '../../types';

export const CrossIcon = ({
  width = 24,
  height = 24,
  color = '#fff',
}: IconType) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2 2.4C15.6418 1.95817 15.6418 1.24183 15.2 0.8C14.7582 0.358172 14.0418 0.358172 13.6 0.8L8 6.4L2.4 0.8C1.95817 0.358172 1.24183 0.358172 0.8 0.8C0.358172 1.24183 0.358172 1.95817 0.8 2.4L6.4 8L0.8 13.6C0.358172 14.0418 0.358172 14.7582 0.8 15.2C1.24183 15.6418 1.95817 15.6418 2.4 15.2L8 9.6L13.6 15.2C14.0418 15.6418 14.7582 15.6418 15.2 15.2C15.6418 14.7582 15.6418 14.0418 15.2 13.6L9.6 8L15.2 2.4Z"
      fill={color}
    />
  </svg>
);
